import axios from 'axios';
import { auth } from '../firebaseClient';

const apiBaseUrlFromEnv = (process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/$/, '');
const resolvedApiBaseUrl = apiBaseUrlFromEnv || (window.location.hostname === 'localhost' ? 'http://localhost:3001' : window.location.origin);

const apiClient = axios.create({
  baseURL: `${resolvedApiBaseUrl}/api`,
});

apiClient.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
